import Swiper from 'swiper/bundle';

var Testimonials = function () {
    var sliders = document.querySelectorAll('.testimonials');

    if (!sliders.length) return;

    sliders.forEach(function (slider) {
        if (!(slider instanceof Element)) return;

        var swiperEl = slider.querySelector('.testimonials__swiper');
        if (!swiperEl) return;

        var swiperWrapper = swiperEl.querySelector('.swiper-wrapper');
        if (!swiperWrapper) return;

        new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: false,
            pagination: {
                el: slider.querySelector('.testimonials__pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: slider.querySelector('.testimonials__nav--next'),
                prevEl: slider.querySelector('.testimonials__nav--prev'),
            },
        });
    });
};

export default Testimonials;
